import Image from "next/image";

type RatingsStarsProps = {
  rating: string;
};

export const RatingsStars = ({ rating }: RatingsStarsProps) => {
  return (
    <div className="flex items-center">
      <p className="mr-2 -mb-1 text-[18px] font-black text-[#FEA500] xs:mr-4 xs:text-[25px]">
        {rating}
      </p>

      <div className="relative">
        <div className="flex min-w-[100px] max-w-[100px] xs:min-w-[150px] xs:max-w-[150px]">
          {Array.from({ length: 5 }, (_, index) => (
            <Image
              key={index}
              src="/content/icons/empty-star.svg"
              alt="star"
              width={30}
              height={30}
            />
          ))}
        </div>
        <div
          className="flex overflow-hidden absolute top-0"
          style={{ width: (parseFloat(rating) * 100) / 5 + "%" }}
        >
          <div className="flex min-w-[100px] max-w-[100px] xs:min-w-[150px] xs:max-w-[150px]">
            {Array.from({ length: 5 }, (_, index) => (
              <Image
                key={index}
                src="/content/icons/full-star.svg"
                alt="star"
                width={30}
                height={30}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
